import React, { Component } from "react"
import { Input, Form, Button } from "semantic-ui-react"
import validator from "validator"
import { compose } from "redux"
import { connect } from "react-redux"
//component
import { NotificationManage } from "../components/NotificationManage"
import * as history_actions from "../actions/action_history"

//material ui
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { SubscriptionBoxStyle } from "../containers/Style/SubscriptionBoxStyle"
import MailOutlineIcon from "@material-ui/icons/MailOutline"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"

class SubscribeModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			email: "",
			erremail: false
		}
	}

	onChange = (e) => {
		this.setState({ email: e.target.value, erremail: false })
	}
	handleSubscribe = (t) => {
		if (!validator.isEmail(this.state.email)) {
			this.setState({ erremail: true })
		} else {
			this.setState({ erremail: false, email: "" })
			this.props
				.subscribe_new(this.state.email)
				.then((res) => {
					NotificationManage(
						"success",
						`${t("NotificationManager.user.thanksub")}`,
						`${t("NotificationManager.status.success")}`
					)
					this.props.handleDialogCloseSubscribe()
				})
				.catch((err) => {
					NotificationManage(
						"info",
						`${t("NotificationManager.user.subscribed")}`,
						`${t("NotificationManager.status.success")}`
					)
					this.props.handleDialogCloseSubscribe()
				})
			this.setState({ email: "" })
		}
	}
	render() {
		const {
			t,
			OpenDialogSubscribe,
			handleDialogCloseSubscribe,
			classes
		} = this.props
		const { email, erremail } = this.state
		return (
			<Dialog
				fullWidth
				maxWidth="sm"
				open={OpenDialogSubscribe}
				onClose={handleDialogCloseSubscribe}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogContent>
					<div style={{ width: "100%", textAlign: "end" }}>
						<IconButton
							aria-label="handleDialogClose"
							onClick={handleDialogCloseSubscribe}
						>
							<CloseIcon />
						</IconButton>
					</div>
					<Form
						onSubmit={() => this.handleSubscribe(t)}
						style={{ padding: 20, paddingTop: 0 }}
					>
						<div className={classes.header_area}>
							<MailOutlineIcon />
							<Typography variant="h5" className={classes.header_text}>
								{t("Subscription.SubscribeEmail")}
							</Typography>
							<Input
								action
								error={erremail}
								type="text"
								placeholder={t("Subscription.EnterYourEMail")}
								fluid
								value={email}
								onChange={this.onChange}
							>
								<input />
								<Button
									type="submit"
									color="violet"
									disabled={this.state.email.length === 0}
								>
									{t("Subscription.Subscribe")}
								</Button>
							</Input>
						</div>
						<div className={classes.checkbox}>
							<Typography className={classes.text}>
								{t("Subscription.SubscribeAccept")}
							</Typography>
							<Typography className={classes.text}>
								{t("Subscription.SubscribeAccept2")}
							</Typography>
						</div>
					</Form>
				</DialogContent>
			</Dialog>
		)
	}
}
SubscribeModal.propTypes = {
	classes: PropTypes.object.isRequired
}
function mapStateToProps(reduxState) {
	return {
		user: reduxState.UserReducer.user,
		userInfo: reduxState.UserReducer.userInfo
	}
}
const mapDispatchToProps = function (dispatch) {
	return {
		subscribe_new: (email) => dispatch(history_actions.subscribe_new(email))
	}
}
export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withStyles(SubscriptionBoxStyle)
)(SubscribeModal)
